import React from "react"
import FinddDatePicker from "../common/FinddDatePicker"
import { blueGrey500 } from "material-ui/styles/colors"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import ChooseHierarchyJobPhaseChipForPunch from "../hierarchy/choose_hierarchy/ChooseHierarchyJobPhaseChipForPunch"
import EquipmentChip from "../equipment/EquipmentChip"
import autobind from "class-autobind"
import CircularProgress from "material-ui/CircularProgress"
import Position_PayType_PayClass_Selector from "../position_paytype_payclass_selector/Position_PayType_PayClass_Selector"
import * as equipmentActions from "../../actions/EquipmentActions"
import * as api from "../../api"
import { IPunchShortDocument, IDate, IEquipmentDocument, IPosition, IJobDocument, IJobPhase, IPunchDocument, IPunchSetDocument, IUIUser } from "../../models"
import moment from "moment"
import PunchDateTimeSelector from "./PunchDateTimeSelector"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"
import * as timeHelper from "../../helpers/timeHelper"
import { checkPhaseFieldAvailable } from "../../helpers/punchHelper"

interface IProps {
    punch?: IPunchDocument
    // SuspensePunchReviewDialog has not PunchSet
    punchSet?: IPunchSetDocument
    user?: IUIUser
    readonly?: boolean
    callingByEquipment?: boolean
    handleForceUpdateDialog?(): void
    handleLoadingPositions?(loading: boolean): void
    //we need to select hierarchy based on employee punch permission, not logged in user punch permission (when the user has more punch rights than the admin)
    //it's possible when full timecard, for example, employee->timecard and payroll->timecard
    //timecards page is not full timecard in the case filter by punch level
    isFullTimecard?: boolean

    //GlobalPunchEdit
    isGlobalPunch?: boolean
    globalPunchEmployees?: IUIUser[]
    commonGlobalPunchData?: IPunchShortDocument
}
interface IState {
    hierarchyLevelId: string
    errorHierarchyId: string
    equipment: IEquipmentDocument
    loadingEquipment: boolean
    positions: IPosition[]
    punchPosition: IPosition
    errorPunchPosition: string
    positionId: string
    payClassId: string
    allowChangeEquipment: boolean
    payTypeId: string
    errorPayTypeId: string
    job: IJobDocument
    phase: IJobPhase
    hierarchyLevelIntentionalChanged: boolean
    dateTime: IDate
    disableDateTime: boolean
    dayGroupingDate: IDate
    disableDayGroupingDate: boolean
}

export default class EditPunchForm extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            hierarchyLevelId: props.isGlobalPunch ? props.commonGlobalPunchData.HierarchyItemId : props.punch.HierarchyItemId,
            errorHierarchyId: null,
            job: null,
            phase: null,
            equipment: null,
            loadingEquipment: false,
            positions: [],
            punchPosition: null,
            errorPunchPosition: null,
            positionId: props.isGlobalPunch ? props.commonGlobalPunchData.PositionId : props.punch.PositionId,
            payClassId: props.isGlobalPunch ? props.commonGlobalPunchData.PayClassId : props.punch.PayClassId,
            allowChangeEquipment: this.props.callingByEquipment ? false : AccountStore.getCurrentAccountSettings().FeatureSettings.EnableEquipment,
            payTypeId: props.isGlobalPunch ? props.commonGlobalPunchData.PayTypeId : props.punch.PayTypeId,
            errorPayTypeId: null,
            hierarchyLevelIntentionalChanged: false,
            dateTime: !props.isGlobalPunch && timeHelper.keepConvertUTCToLocal(props.punch.RoundingRuleId ? props.punch.RoundedDateTimeLocal : props.punch.DateTimeLocal),
            disableDateTime: false,
            dayGroupingDate: !props.isGlobalPunch && timeHelper.keepConvertUTCToLocal(props.punch.DayGroupingTimeLocal),
            disableDayGroupingDate: false
        }
        autobind(this)
    }

    componentDidMount() {
        this.loadEquipmentInfo()
        this.loadJobPhase()
    }

    loadEquipmentInfo() {
        const equipmentId = this.getEquipmentId()
        equipmentId && (
            equipmentId === AccountStore.DiffEquipmentId ?
                this.setState({
                    equipment: AccountStore.DiffEquipment,
                    loadingEquipment: false
                }) :
                this.setState({ loadingEquipment: true }, () =>
                    equipmentActions.getEquipmentForChip(equipmentId).then(result =>
                        this.setState({
                            equipment: result as IEquipmentDocument,
                            loadingEquipment: false
                        })
                    )
                )
        )
    }

    getEquipmentId() {
        return this.props.isGlobalPunch ? this.props.commonGlobalPunchData.EquipmentId : this.props.punch.EquipmentId
    }

    loadJobPhase() {
        const jobId = this.props.isGlobalPunch ? this.props.commonGlobalPunchData.JobId : this.props.punch.JobId
        const phaseId = this.props.isGlobalPunch ? this.props.commonGlobalPunchData.PhaseId : this.props.punch.PhaseId
        jobId && (
            jobId === AccountStore.DiffJobId ?
                this.setState({
                    job: AccountStore.DiffJob,
                    phase: phaseId === AccountStore.DiffPhaseId ? AccountStore.DiffPhase : null
                }) :
                api.getJob(jobId).then(res => {
                    const job: IJobDocument = res.data
                    this.setState({
                        job,
                        phase: phaseId ?
                            phaseId === AccountStore.DiffPhaseId ?
                                AccountStore.DiffPhase :
                                job.Phases.find(item => item.Id === phaseId) :
                            null
                    })
                })
        )
    }

    render() {
        return (
            <div
                style={{
                    paddingLeft: 10,
                    textAlign: this.state.allowChangeEquipment && this.state.loadingEquipment ? "center" : "left"
                }}
            >
                <div style={{ borderTop: "solid 1px #cccccc", paddingTop: 10 }}>
                    {this.state.allowChangeEquipment && this.state.loadingEquipment ?
                        <CircularProgress /> :
                        <div>
                            {!this.props.isGlobalPunch &&
                                <PunchDateTimeSelector
                                    hierarchyId={this.state.hierarchyLevelId}
                                    jobId={this.state.job ? this.state.job.Id : null}
                                    date={this.state.dateTime}
                                    hour={moment(this.state.dateTime).hour()}
                                    minute={moment(this.state.dateTime).minute()}
                                    readonly={this.props.readonly || this.state.disableDateTime}
                                    handleChange={(date, hour, minute) => this.setState({ dateTime: moment(date).hour(hour).minute(minute), disableDayGroupingDate: true })}
                                />
                            }
                            <div style={{ position: "relative" }}>
                                <ChooseHierarchyJobPhaseChipForPunch
                                    hideIcon={false}
                                    readonly={this.props.readonly}
                                    hierarchyChipLabel={strings.ChoosePunchHierarchy}
                                    jobChipLabel={checkJobFieldAvailable('singular') ? `Choose ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Choose_Job}
                                    phaseChipLabel={ checkPhaseFieldAvailable("singular") ? `Choose ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}` : strings.Choose_Phase}
                                    employee={this.props.user}
                                    punchHierarchyItemId={this.state.hierarchyLevelId}
                                    jobId={this.state.job ? this.state.job.Id : null}
                                    phaseId={this.state.phase ? this.state.phase.Id : null}
                                    handleSelectHierarchyJobPhase={(hierarchyLevelId, errorHierarchyId, job, phase, intentionalChanged) =>
                                        this.setState({
                                            hierarchyLevelId,
                                            errorHierarchyId,
                                            job: job,
                                            phase: phase,
                                            hierarchyLevelIntentionalChanged: intentionalChanged ? true : this.state.hierarchyLevelIntentionalChanged
                                        })
                                    }
                                    isEmployeePermissionPriority={this.props.isFullTimecard}
                                    isGlobalPunch={this.props.isGlobalPunch}
                                    globalPunchEmployees={this.props.globalPunchEmployees as IUIUser[]}
                                    searchJobByEmpPermission={this.props.isGlobalPunch ? false : true}
                                    byEquipment={this.props.user ? false : true}
                                />
                                <Position_PayType_PayClass_Selector
                                    readonly={this.props.readonly}
                                    date={this.state.dateTime}
                                    employee={this.props.user}
                                    hierarchyId={this.state.hierarchyLevelId}
                                    shiftId={this.props.isGlobalPunch ? null : this.props.punch.ShiftId}
                                    jobId={this.state.job ? this.state.job.Id : null}
                                    phaseId={this.state.phase ? this.state.phase.Id : null}
                                    selectedPositionId={this.state.positionId}
                                    selectedPayTypeId={this.state.payTypeId}
                                    selectedPayClassId={this.state.payClassId}
                                    keepPropsPayClassId_PayTypeId
                                    handleLoadingPositions={loading => this.props.handleLoadingPositions && this.props.handleLoadingPositions(loading)}
                                    handleSelectPosition={(position, errorPunchPosition) =>
                                        this.setState({
                                            punchPosition: position,
                                            positionId: position ? position.Id : null,
                                            errorPunchPosition
                                        })
                                    }
                                    handleSelectPayClass={payClassId => this.setState({ payClassId })}
                                    handleSelectPayType={(payTypeId, errorPayTypeId) => this.setState({ payTypeId, errorPayTypeId }, () =>
                                        this.props.handleForceUpdateDialog &&
                                        this.props.handleForceUpdateDialog()
                                    )}
                                    referencePunchPositionDocumentId={this.props.isGlobalPunch ? null : this.props.punch.Id}
                                    isGlobalPunch={this.props.isGlobalPunch}
                                    isGlobalPunchEdit={this.props.isGlobalPunch}
                                    globalPunchEmployees={this.props.globalPunchEmployees as IUIUser[]}
                                    commonGlobalPunchData={this.props.commonGlobalPunchData}
                                    hierarchyLevelIntentionalChanged={this.state.hierarchyLevelIntentionalChanged}
                                />
                            </div>
                            {!this.props.isGlobalPunch &&
                                this.props.punchSet &&
                                AccountStore.getCalculationDayGroupEnabled() &&
                                !this.props.punchSet.Splited && !this.props.punchSet.HolidayName && !this.props.punchSet.TimeOffRequestId &&
                                this.props.punchSet.PunchInId && this.props.punchSet.PunchOutId &&
                                <div style={{ width: 500, fontSize: 12, marginTop: 15, marginBottom: 15 }}>
                                    <div style={{ marginLeft: 25 }}>
                                        {strings.Punch_set_calculation_date}
                                    </div>
                                    <i className="fa fa-calendar" style={{ marginRight: 10 }} />
                                    <FinddDatePicker
                                        style={{ display: "inline-block" }}
                                        disabled={this.props.readonly || this.state.disableDayGroupingDate}
                                        hintText={strings.Select_a_date}
                                        onChange={(_i, value) => {
                                            const date = moment(value)
                                            this.setState({ dayGroupingDate: moment(this.state.dayGroupingDate).year(date.year()).month(date.month()).date(date.date()), disableDateTime: true })
                                        }}
                                        value={moment(this.state.dayGroupingDate).toDate()}
                                        cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                                        firstDayOfWeek={0}
                                    />
                                </div>
                            }
                            {this.state.allowChangeEquipment &&
                                <div style={{ marginTop: 2, marginBottom: 5 }}>
                                    <EquipmentChip
                                        canChange={!this.props.readonly}
                                        defaultEquipmentId={this.getEquipmentId()}
                                        setEquipmentList={equipmentList => this.setState({ equipment: equipmentList.length > 0 ? equipmentList[0] : null })}
                                    />
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
}
